import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { WorkOrderService } from 'src/app/services/workorder.service';
import { WorkOrder } from 'src/app/interfaces/workorder';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SidebarService } from 'src/app/services/sidebar.service';
import { UnsubscriberComponent } from 'src/app/components/shared/unsubscriber.component';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-workorders-tab',
    templateUrl: './workorders-tab.component.html',
    styleUrls: ['./workorders-tab.component.scss'],
    providers: [TranslatePipe],
    standalone: false
})
export class WorkOrderComponent extends UnsubscriberComponent {
  public workOrders$: Observable<WorkOrder[]>;
  public nextWorkOrder$: Observable<WorkOrder>;

  public currentId: string;
  public preloading = false;
  constructor(
    private router: Router,
    public workOrderService: WorkOrderService,
      private sidebarService: SidebarService,
      private toastrService: ToastrService
  ) {
    super();
    this.workOrders$ = this.workOrderService.workOrders$;
    this.nextWorkOrder$ = this.workOrderService.nextWorkOrder$.pipe(
      tap((nextWorkOrder) => {
        if (nextWorkOrder)
          this.handleClick(nextWorkOrder);
      })
    );
    this.subscriptions.add(
      this.sidebarService.isSidebarOpen$.subscribe((isOpen) => {
        if (isOpen) this.workOrderService.loadWorkItems();
      })
    );
    this.subscriptions.add(
      this.workOrderService.currentWorkItemId.subscribe((itemId: string) => this.currentId = itemId)
    );
  }

  public refreshList() {
    this.workOrderService.loadWorkItems();
    }

    public preload(event) {
        this.preloading = true;
        this.toastrService.info("Preloading");
        this.workOrderService.preloadItems().subscribe((res) => {
            this.toastrService.success("Preloading ready");
        this.preloading = false;
        });
    }


  //wallets/payment/
  public handleClick(workOrder: WorkOrder): void {

    this.workOrderService.handeClick(workOrder);
    //if (workOrder.messageType === 'EXEMPTION')
    //  this.router.navigate(['caz-work', 'registration', workOrder.id]);
    //else if (workOrder.messageType === 'REPRESENTATION')
    //  this.router.navigate(['caz-work', 'rep', workOrder.id]);
    //else if (workOrder.messageType === undefined)
    //  this.router.navigate(['wallets', 'payment', workOrder.id]);
    //else
   
    // if(workOrder.messageType === 'WORK_OBJECTION')
    // {
    //   sessionStorage.setItem('workItemId', workOrder.workItemId);
    //   sessionStorage.setItem('userId', workOrder.userId);
    //   this.router.navigate(['kmt', 'objection',  workOrder.id]);
    // }
    //   else
    //   this.router.navigate(['workorders', 'workitem', workOrder.workItemId]);
  }
}
